import { render, staticRenderFns } from "./custom-progress.vue?vue&type=template&id=1fae033e&scoped=true"
import script from "./custom-progress.vue?vue&type=script&lang=js"
export * from "./custom-progress.vue?vue&type=script&lang=js"
import style0 from "./custom-progress.vue?vue&type=style&index=0&id=1fae033e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae033e",
  null
  
)

export default component.exports